import { useMemo } from "react";
import { composeTokens } from "../utils/composeTokens.js";
function useTokens(text, pattern, caseSensitive = false) {
  return useMemo(() => {
    return composeTokens(text, pattern, caseSensitive);
  }, [text, pattern, caseSensitive]);
}
export {
  useTokens
};
//# sourceMappingURL=useTokens.js.map
